import React from 'react'
import './footer.css';
import LinkedIn from '../../images/technologies_icons/LINKEDIN_ico.svg';
import GitHub from '../../images/technologies_icons/GITHUB_ico.svg';
import Behance from '../../images/technologies_icons/BEHANCE_ico.svg';

export default function Footer()
{
    return(
        <div className="footer">
            <div id="footer-element-1" className="footer-element">
                <div className="wrapper-footer-cpyr">
                    <p className="cpyr-vg">
                    Vivian Gómez
                    </p>
                    <p className="copyright">
                    © Copyright 2020
                    </p>
                </div>
            </div>
            <div id="footer-element-2" className="footer-element">
                <div className="wrapper-footer-phr">
                    <p className="footer-phr">
                        "To live a creative life, we must lose our fear of being wrong."
                    </p>
                    <p className="footer-phr-author">
                    - Joseph Chilton Pearce
                    </p>
                </div>
            </div>
            <div id="footer-element-3" className="footer-element">
                <div className="wrapper-footer-contact">
                    <p className="contact-me">
                         Contact me
                    </p>
                    <div>
                    <a href="https://www.linkedin.com/in/vivian-g%C3%B3mez-cubillos-79499b18a/" className="footer-links"  target="_blank" rel="noopener noreferrer">
                    <img  src={LinkedIn} alt="LinkedIn"/>
                    </a>
                    <a href="https://github.com/VivianGomez" className="footer-links"  target="_blank" rel="noopener noreferrer">
                    <img  src={GitHub} alt="Github"/>
                    </a>
                    <a href="https://www.behance.net/vivi_15gmz3b9a" className="footer-links"  target="_blank" rel="noopener noreferrer">
                    <img  src={Behance} alt="Behance"/>
                    </a>
                    </div>
                </div>
            </div>
            
        </div>
    )
}